import { takeEvery, call, put } from 'redux-saga/effects';
import { ADD_CAROUSEL_DATA, REMOVE_CAROUSEL_DATA, UPDATE_CAROUSEL_DATA, GET_CAROUSEL_DATA } from 'store/actionTypes';
import { GetCollectionDocs } from 'store/services/collection';
import { SetDocService, GetDocService, RemoveDocService } from 'store/services/document';
import { message } from 'antd';

// watchers
export function* AddCarouselDataWatcher() {
    yield takeEvery(ADD_CAROUSEL_DATA.WATCH, AddCarouselDataWorker);
}

export function* UpdateCarouselDataWatcher() {
    yield takeEvery(UPDATE_CAROUSEL_DATA.WATCH, UpdateCarouselDataWorker);
}

export function* RemoveCarouselDataWatcher() {
    yield takeEvery(REMOVE_CAROUSEL_DATA.WATCH, RemoveCarouselDataWorker);
}

export function* GetCarouselDataWatcher() {
    yield takeEvery(GET_CAROUSEL_DATA.WATCH, GetCarouselDataWorker);
}


function* RemoveCarouselDataWorker({ payload }) {
    try {
        yield put({ type: REMOVE_CAROUSEL_DATA.LOAD });
        const response = yield call(RemoveDocService, payload)
        yield put({ type: REMOVE_CAROUSEL_DATA.SUCCESS, payload: payload.document });
    } catch (e) {
        message.error(e.message);
        yield put({ type: REMOVE_CAROUSEL_DATA.FAIL, payload: e.message });
    }
}
function* AddCarouselDataWorker({ payload }) {
    const { data } = payload;
    try {
        yield put({ type: ADD_CAROUSEL_DATA.LOAD });
        yield call(SetDocService, payload)
        yield put({ type: ADD_CAROUSEL_DATA.SUCCESS, payload: data });
        payload.cb && payload.cb();
    } catch (e) {
        message.error(e.message);
        yield put({ type: ADD_CAROUSEL_DATA.FAIL, payload: e.message });
    }
}
function* UpdateCarouselDataWorker({ payload }) {
    try {
        yield put({ type: UPDATE_CAROUSEL_DATA.LOAD });
        const response = yield call(SetDocService, payload)
        yield put({ type: UPDATE_CAROUSEL_DATA.SUCCESS, payload });
        payload.cb && payload.cb();
    } catch (e) {
        message.error(e.message);
        yield put({ type: UPDATE_CAROUSEL_DATA.FAIL, payload: e.message });
    }
}

function* GetCarouselDataWorker({ payload }) {
    try {
        yield put({ type: GET_CAROUSEL_DATA.LOAD });
        const response = yield call(GetCollectionDocs, payload)
        yield put({ type: GET_CAROUSEL_DATA.SUCCESS, payload: response });
    } catch (e) {
        message.error(e.message);
        yield put({ type: GET_CAROUSEL_DATA.FAIL, payload: e.message });
    }
}




